import { Tag } from "antd";
import React, { Component } from "react";
import { ModalItem, TableItem } from "../../../../Components/Items";

// Ver insumo: consulta de solo lectura de las familias donde se usa. Las
// familias vienen pobladas en el select del catalogo, asi que no hace falta
// otra consulta.
class FamiliasInsumoImplementacion extends Component {
    render() {
        const insumo = this.props.insumo;
        if (!insumo) return null;

        const familias = (insumo.familiaImplementacionIds || []).filter(
            (familia) => familia && typeof familia === "object"
        );

        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                width: "20%",
                render: (value) => (value || value === 0 ? value : "-"),
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "55%",
            },
            {
                title: "Serie",
                dataIndex: "serie",
                key: "serie",
                width: "25%",
                render: (value) => value || "-",
            },
        ];

        return (
            <ModalItem
                title="Familias del insumo"
                visible={this.props.visible}
                onCancel={this.props.cerrarFamiliasInsumoImplementacion}
                width={window.innerWidth > 1000 ? "60%" : "95%"}
                paddingTop
            >
                <div
                    style={{
                        background: "#fff",
                        border: "1px solid #eef1f2",
                        borderRadius: 12,
                        padding: "10px 14px",
                        marginBottom: 12,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 10,
                            flexWrap: "wrap",
                        }}
                    >
                        <span style={{ fontSize: 15, fontWeight: 700, color: "#3c4b53" }}>
                            {insumo.clave ? insumo.clave + " · " : ""}
                            {insumo.descripcion}
                        </span>
                        <Tag color="cyan">
                            {familias.length === 1
                                ? "1 familia relacionada"
                                : familias.length + " familias relacionadas"}
                        </Tag>
                    </div>
                    {insumo.unidad ? (
                        <div style={{ fontSize: 12, color: "#7b8a92", marginTop: 4 }}>
                            Unidad: {insumo.unidad}
                        </div>
                    ) : null}
                </div>

                {familias.length === 0 ? (
                    <div
                        style={{
                            background: "#fafbfc",
                            border: "1px dashed #dfe4e6",
                            borderRadius: 12,
                            padding: "26px 14px",
                            textAlign: "center",
                            fontSize: 13,
                            color: "#7b8a92",
                            marginBottom: 10,
                        }}
                    >
                        Este insumo aún no está relacionado con ninguna familia.
                    </div>
                ) : (
                    <TableItem
                        size="small"
                        dataSource={familias}
                        columns={columns}
                        scroll={{ x: "max-content" }}
                    />
                )}
            </ModalItem>
        );
    }
}

export default FamiliasInsumoImplementacion;
